import type { GetIndicatorAuditByIdResponseRow } from '@risksmart-app/trpc/types';
import type { GetIndicatorAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIndicatorAuditByIdArgs = {
  id: string;
};

export const useGetIndicatorAuditById = createQueryHook<
  UseGetIndicatorAuditByIdArgs,
  GetIndicatorAuditByIdResponseRow[],
  GetIndicatorAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIndicatorAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator_audit: data }),
  graphqlDocument: GetIndicatorAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
